export default __webpack_public_path__ + "static/media/labyrinthen-property-01.e6a0fadf.jpg";